import { render } from "./Playbooks.vue?vue&type=template&id=17627911&scoped=true"
import script from "./Playbooks.vue?vue&type=script&lang=js"
export * from "./Playbooks.vue?vue&type=script&lang=js"

import "./Playbooks.vue?vue&type=style&index=0&id=17627911&lang=scss"
import "./Playbooks.vue?vue&type=style&index=1&id=17627911&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17627911"]])

export default __exports__